import * as React from "react";
import styled from "styled-components";
import { Content } from "./MIView1";
import RightArrow from '../resources/right-arrow.svg';
import { useNavigate } from 'react-router-dom';
import Alcohol2View from "./Alcohol2View";
import AlcoholIntercourseView from "./AlcoholIntercourseView";
import ProgressBar2 from "./ProgressBar2";
import Risk from "./Risk";
import Abuse from "./Abuse";
import HIV from "./HIV";
import Loader from '../components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackButton from '../components/BackButton';
import calculateMetrics2 from '../utils/calculateMetrics2'; // default export
import { saveSubmission } from '../api/saveSubmission';

const MIView2 = () => {
  const [nextButton, setNextButton] = React.useState(false);
  const [index, setIndex] = React.useState(0);
  const [selected, setSelected] = React.useState("alcohol");
  const [loading, setLoading] = React.useState(true);
  const [showUnanswered, setShowUnanswered] = React.useState(false);
  const history = useNavigate();
  const scrollRef = React.useRef(null);

  // --- mount logs
  React.useEffect(() => {
    console.log("[MI2] Mount");
  }, []);

  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [index]);

  const [studentResponses, setStudentResponses] = React.useState(
    sessionStorage.getItem("studentResponses")
      ? JSON.parse(sessionStorage.getItem("studentResponses"))
      : {}
  );

  const setStudentResponseData = (data) => {
    const newStudentResponses = { ...studentResponses, ...data };
    setStudentResponses(newStudentResponses);
    console.log("[MI2] setStudentResponseData merged:", newStudentResponses);
  };

  const age = sessionStorage.getItem("age");

  const components = [
    {
      title: "alcohol",
      view: (
        <Alcohol2View
          setAlcoholInfoData={setStudentResponseData}
          setNextButton={setNextButton}
          showUnanswered={showUnanswered}
          onAllAnswered={setShowUnanswered}
        />
      ),
    },
    {
      title: "intercourse",
      view: (
        <AlcoholIntercourseView
          age={age}
          setAlcoholIntercourseInfoData={setStudentResponseData}
          setNextButton={setNextButton}
          showUnanswered={showUnanswered}
          onAllAnswered={setShowUnanswered}
        />
      ),
    },
    {
      title: "risk",
      view: (
        <Risk
          age={age}
          setRiskInfoData={setStudentResponseData}
          setNextButton={setNextButton}
          showUnanswered={showUnanswered}
          onAllAnswered={setShowUnanswered}
        />
      ),
    },
    {
      title: "abuse",
      view: (
        <Abuse
          setAbuseInfoData={setStudentResponseData}
          setNextButton={setNextButton}
          showUnanswered={showUnanswered}
          onAllAnswered={setShowUnanswered}
        />
      ),
    },
    {
      title: "hiv",
      view: (
        <HIV
          age={age}
          setHIVInfoData={setStudentResponseData}
          setNextButton={setNextButton}
          showUnanswered={showUnanswered}
          onAllAnswered={setShowUnanswered}
        />
      ),
    },
  ];

  const onBack = () => {
    console.log("[MI2] Back clicked. index:", index);
    if (index > 0) {
      const newIndex = index - 1;
      setIndex(newIndex);
      setSelected(components[newIndex].title);
      sessionStorage.setItem("selectedPageIndex", String(newIndex));
      setShowUnanswered(false);
      setNextButton(true);
      console.log("[MI2] Moved back to:", components[newIndex].title);
    } else {
      console.log("[MI2] At first step; staying put.");
      // history(-1); // keep disabled unless you want to exit MI2 on first screen
    }
  };

  const onSectionChange = async () => {
    console.log("[MI2] Next clicked. index:", index, "selected:", selected, "nextButton:", nextButton);
    if (nextButton === false) {
      console.warn("[MI2] Blocking progress: required questions not answered.");
      toast.error('Please answer all marked questions before moving to the next section.');
      setShowUnanswered(true);
      return;
    }

    const isLastStep = components[index].title === "hiv";
    console.log("[MI2] isLastStep:", isLastStep);

    if (!isLastStep) {
      // advance to next section
      const nextIdx = index + 1;
      const nextTitle = components[nextIdx].title;
      console.log("[MI2] Advancing to step:", nextTitle, "saving studentResponses to sessionStorage.");
      setSelected(nextTitle);
      setIndex(nextIdx);
      // ✅ Clean object logs (no giant JSON string)
      const mi2Parsed = JSON.parse(sessionStorage.getItem("MI2Metrics") || "{}");
      console.log("[MI2] parsed from sessionStorage:", mi2Parsed);

      return;
    }

    // LAST STEP → compute metrics and route to MI2 report
    const PARTID = sessionStorage.getItem("PARTID") || "LOCAL_PARTID_" + Date.now();
    const savedAge = sessionStorage.getItem("age") || studentResponses["age"];
    const gender = sessionStorage.getItem("gender_assigned_at_birth") || studentResponses["gender_assigned_at_birth"];

    try {
      if (typeof calculateMetrics2 !== "function") {
        throw new Error("calculateMetrics2 is not a function. Check your import/export.");
      }

      console.log("[MI2] Inputs to calculateMetrics2:", {
        PARTID,
        age: savedAge,
        gender_assigned_at_birth: gender,
        studentResponses
      });

      const metrics2 = calculateMetrics2({
        ...studentResponses,
        age: savedAge,
        gender_assigned_at_birth: gender,
      });

      console.log("[MI2] Calculated metrics2:", metrics2);
// ----- SAVE MI2 TO BACKEND (Amplify GraphQL) -----
const participantId = PARTID;

// Send only what you want to persist as demographics in MI2 (often none);
// pass null/omit if you don’t want to store any here.
const demographics = null;

await saveSubmission({
  participantId,
  formType: 'MI2',
  demographics,           // null is fine
  raw: studentResponses,  // the full pre-calc MI2 answers
  metrics: metrics2,      // MI2 post-calc
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
});
// -----------------------------------------------

      // preserve flags and essentials; clear the rest
      const keep = {
        PARTID,
        age: String(savedAge ?? ""), // store as strings for sessionStorage clarity
        gender_assigned_at_birth: String(gender ?? ""),
        logged_in: "true",
        mi_metrics1_submitted: String(sessionStorage.getItem("mi_metrics1_submitted") || 1),
        mi_metrics2_submitted: "1",
      };

      console.log("[MI2] sessionStorage before clear:", {
        ...sessionStorage
      });

      sessionStorage.clear();
      Object.entries(keep).forEach(([k, v]) => sessionStorage.setItem(k, v));
      sessionStorage.setItem("MI2Metrics", JSON.stringify(metrics2));

      console.log("[MI2] sessionStorage after save:", {
        PARTID: sessionStorage.getItem("PARTID"),
        age: sessionStorage.getItem("age"),
        gender_assigned_at_birth: sessionStorage.getItem("gender_assigned_at_birth"),
        logged_in: sessionStorage.getItem("logged_in"),
        mi_metrics1_submitted: sessionStorage.getItem("mi_metrics1_submitted"),
        mi_metrics2_submitted: sessionStorage.getItem("mi_metrics2_submitted"),
        MI2Metrics: sessionStorage.getItem("MI2Metrics")
      });

      history("/MI2/Metrics");
    } catch (err) {
      console.error("Failed to calculate MI2 metrics:", err);
      toast.error(`Could not process MI2 report data.`);
    }
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      const loggedIn = sessionStorage.getItem('logged_in');
      const mi1 = sessionStorage.getItem('mi_metrics1_submitted');
      console.log("[MI2] Gate check -> logged_in:", loggedIn, "mi_metrics1_submitted:", mi1);

      if (!loggedIn || parseInt(mi1) === 0) {
        console.warn("[MI2] Gate failed. Redirecting to '/'.");
        history('/');
      }
      setLoading(false);

      const savedIndex = sessionStorage.getItem("selectedPageIndex");
const idx = Number.parseInt(savedIndex ?? "0", 10);
if (!Number.isNaN(idx) && idx > 0 && components[idx]) {
  console.log("[MI2] Restoring selected step from session:", components[idx].title, idx);
  setSelected(components[idx].title);
  setIndex(idx);
} else {
  console.log("[MI2] Setting selectedPageIndex -> 0");
  sessionStorage.setItem("selectedPageIndex", "0");
}

    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    loading ? <div><Loader /></div> :
    <VapeWrap ref={scrollRef}>
      <ToastContainer position="top-center" closeOnClick style={{ width: 'auto' }} />
      <Content>
        <ProgressBarWrap>
          <ProgressBar2 selected={selected} alcohol2Intercourse={Number(age) < 18} />
        </ProgressBarWrap>
        <Form>
          {components.filter((i) => i.title === selected)[0]?.view}
          <ButtonRow>
            <BackButton enabled={index > 0} onClick={onBack} />
            <Button
              style={{ backgroundColor: nextButton ? "#025dc7" : "grey" }}
              onClick={onSectionChange}
            >
              Next <img src={RightArrow} height={30} />
            </Button>
          </ButtonRow>
        </Form>
      </Content>
    </VapeWrap>
  );
};

const VapeWrap = styled.article`
  width: 100%;
  overflow-y: scroll;
  height: -webkit-fill-available;
  background-color: #D3EEFF;
  display: flex;
  flex-direction: column;
  padding: 0 0 40px;
  h2{ font-size: 22px; }
  h3{ font-size: 20px; margin: 0; }
  p{ font-size: 17px; }
  @media only screen and (max-width: 780px) {
    h2{ font-size: 18px; }
    h3{ font-size: 16px; line-height: 17px; }
    p{ font-size: 14px; }
  }
  @media only screen and (max-width: 576px) {
    h2{ font-size: 16px; }
    h3{ font-size: 14px; line-height: 17px; }
    p{ font-size: 12px; }
  }
`;
const ProgressBarWrap = styled.section`
  display: flex;
  justify-content: center;
  margin: 20px 0 20px 0;
  width: 100%;
`;

const Form = styled.section`
  width: 80%;
  position: relative;
  background-color: white;
  margin: 20px 100px;
  padding: 30px;
  @media only screen and (max-width: 780px) {
    margin: 20px 100px;
    padding: 30px;
  }
  @media only screen and (max-width: 576px) {
    width: 77%;
    margin: 20px 100px;
    padding: 30px;
  }
`;

const Button = styled.button`
  background-color: #025dc7;
  cursor: pointer;
  border: none;
  border-radius: 25px;
  color: white;
  display: flex;
  align-items: center;
  img{ margin-left: 10px; }
  padding: 0px 20px;
`;

const ButtonRow = styled.div`
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
`;

export default MIView2;